var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTruckIconBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "159px",
    height: "93px",
    viewBox: "0 0 159 93",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "graph/truck_black") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "graph/truck_black",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "graph/truck_grey"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    strokeOpacity: 0.87,
    stroke: "#000000",
    strokeWidth: 7,
    cx: 112,
    cy: 78,
    r: 11.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-7",
    strokeOpacity: 0.87,
    stroke: "#000000",
    strokeWidth: 7,
    cx: 25,
    cy: 78,
    r: 11.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-5",
    strokeOpacity: 0.87,
    stroke: "#000000",
    strokeWidth: 7,
    cx: 144,
    cy: 78,
    r: 11.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.762389,63 L132.238417,63 C131.538464,63.4095988 130.83532,63.9675661 130.128984,64.6739017 C129.422649,65.3802373 128.713122,66.2349413 128.000403,67.2380138 C127.30045,66.2349413 126.597306,65.3802373 125.890971,64.6739017 C125.184635,63.9675661 124.475108,63.4095988 123.762389,63 Z",
    id: "Path-3",
    fillOpacity: 0.87,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,1 C88.2022882,0.333333333 88.5356216,0 89,0 C89.4643784,0 89.7977118,0.333333333 90,1 L91,3 L91,28.4685732 C91,28.8008545 91.16505,29.1114335 91.4404418,29.2973642 L93.5595582,30.7280857 C93.83495,30.9140164 94,31.2245954 94,31.5568767 L94,57 L92.1150072,59 L89,59 L85.8491331,59 L84,57 L84,31.6524512 C84,31.3290447 84.1564032,31.0256049 84.4198122,30.8379685 L86.5801878,29.2990486 C86.8435968,29.1114121 87,28.8079723 87,28.4845659 L87,3 L88,1 Z",
    id: "Rectangle",
    fillOpacity: 0.87,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,27.1911084 C36.7020668,25.7303695 37.7020668,25 39,25 C42.3333333,25 45,25 47,25 C48.8555127,13.4006009 56.857966,6.06726759 71.0073601,3 L83,3 L83,63 L97,63 L97,66.3366778 C94.4931547,69.5560641 93,73.6036595 93,78 L44,78 C44,67.5065898 35.4934102,59 25,59 C14.5065898,59 6,67.5065898 6,78 L-5.68434189e-14,78 L-5.68434189e-14,48.7695134 C0.692292494,48.0390547 1.79959505,47.4361121 3.32190767,46.9606855 L36,45 L36,27.1911084 Z M42,29 C40.8954305,29 40,29.8954305 40,31 L40,43 C40,44.1045695 40.8954305,45 42,45 L54,45 C55.1045695,45 56,44.1045695 56,43 L56,31 C56,29.8954305 55.1045695,29 54,29 L42,29 Z",
    id: "Combined-Shape",
    fillOpacity: 0.87,
    fill: "#000000"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckIconBlack);
export default __webpack_public_path__ + "static/media/truck_icon_black.3120c14f807c2e8a8806740057bf0fa1.svg";
export { ForwardRef as ReactComponent };